// Styles imports
import Styles from './LoadingBox.module.scss';

const LoadingBox = () => {
  return <div className={Styles.loader}></div>;
};

export default LoadingBox;
